import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { MedicalFeeAmount } from "../../model/medical-fee/medical-fee-amount";
import { StudykeyImage } from "src/app/model/study-report-text";

@Injectable({
  providedIn: "root",
})
export class KeyImageService {
  constructor(private dataService: DataService) {}

  async importKeyImage(
    patientId: number,
    ac: number,
    centerId: number
  ): Promise<StudykeyImage> {
    return await this.dataService
      .post<StudykeyImage>("/KeyImage/ImportImageKeys/", {
        PatientId: patientId,
        Ac: ac,
        CenterId: centerId,
      })
      .toPromise();
  }

  getKeyImageUrl(id: string): string {
    return this.dataService.apiUrl + "/KeyImage/GetImage?id=" + id;
  }
}
